"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("../../../Typography"));
var useStyles_1 = __importDefault(require("./useStyles"));
var HeaderLabel = function (_a) {
    var children = _a.children;
    var classes = (0, useStyles_1.default)();
    if (!children)
        return null;
    return (react_1.default.createElement(Typography_1.default, { variant: "caption", classes: { root: classes.text } }, children));
};
exports.default = HeaderLabel;
